import { NewMemberOfType, NewOrderPartyType } from 'types/order';
import { uniqueKinds } from '../utils';

const EXCLUDED_KINDS = ['Other', 'Unknown'];

export const filterPartiesByName = (parties: NewOrderPartyType[]) => {
  const nameParties = parties
    .map((party) => {
      const { name, member_of, _id, kinds } = party;
      return {
        name,
        member_of,
        id: _id,
        kinds: uniqueKinds(kinds),
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name));

  return nameParties;
};

const groupPartiesByKinds = (
  parties: NewOrderPartyType[],
  shouldIncludeKind: (kind: string) => boolean
) => {
  const kindsParty = parties.reduce<
    Record<string, { id: string; name: string; member_of: NewMemberOfType[] }[]>
  >((acc, { name, kinds, _id, member_of }) => {
    uniqueKinds(kinds)
      .filter((kind) => shouldIncludeKind(kind.trim()))
      .forEach((kind) => {
        const kindClean = kind.trim();
        acc[kindClean] = acc[kindClean]
          ? [...acc[kindClean], { id: _id, name, member_of }]
          : [{ id: _id, name, member_of }];
      });
    return acc;
  }, {});

  return Object.entries(kindsParty)
    .map(([kind, items]) => ({
      kind: kind.trim(),
      parties: items.sort((a, b) => a.name.localeCompare(b.name)),
    }))
    .sort((a, b) => a.kind.localeCompare(b.kind));
};

export const filterPartiesByRole = (parties: NewOrderPartyType[]) =>
  groupPartiesByKinds(parties, (kind) => !EXCLUDED_KINDS.includes(kind));

export const filterPartiesByOthers = (parties: NewOrderPartyType[]) =>
  groupPartiesByKinds(parties, (kind) => EXCLUDED_KINDS.includes(kind));
